import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

interface FormInputDateProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label: string;
  dateFormat?: string;
  disabled?: boolean;
}

export const FormInputDate = <T extends FieldValues>({
  name,
  control,
  label,
  dateFormat = 'DD/MM/YYYY',
  disabled = false,
}: FormInputDateProps<T>) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Controller
        name={name}
        control={control as Control<FieldValues>}
        render={({ field: { onChange, value } }) => (
          <DesktopDatePicker
            label={label}
            inputFormat={dateFormat}
            value={value}
            onChange={onChange}
            disabled={disabled}
            renderInput={(params) => (
              <TextField {...params} helperText="" style={{ width: '100%' }} />
            )}
          />
        )}
      />
    </LocalizationProvider>
  );
};
